import { URL_CODE } from '@match/app-rules-resolver';
import { useSiteData } from 'modules/hooks';

const divinoAmorKey = 'fe0fab3c-441f-4eb5-9a73-7718963822e7';
const matchBrasilKey = '13c72ac2-3c1b-4017-9e2e-cba5feec6a80';
const matchLatamKey = '9463b5e4-452e-4f51-827d-293d0ef8d5ec';
const ourTimeBrasilKey = 'f708e5d9-ca18-4261-93b2-9d74a07c05b0';
const parperfeitoKey = '29087102-736f-4a80-b341-8c8cde220b01';

function useWebchatWidgetKey() {
  const { urlCode } = useSiteData();
  let widgetKey = matchLatamKey;

  switch (urlCode) {
    case URL_CODE.DIVINO_AMOR:
      widgetKey = divinoAmorKey;
      break;
    case URL_CODE.MATCH_BR:
      widgetKey = matchBrasilKey;
      break;
    case URL_CODE.OUR_TIME_BR:
      widgetKey = ourTimeBrasilKey;
      break;
    case URL_CODE.PAR_PERFEITO:
      widgetKey = parperfeitoKey;
      break;
    default:
      // NOTE: Non-specified LATAM pages fall back to Match LATAM widget
      widgetKey = matchLatamKey;
  }

  return {
    widgetKey,
  };
}

export default useWebchatWidgetKey;
